module.exports = __webpack_public_path__ + "static/img/button8.2837e06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/button8.png
// module id = wcdE
// module chunks = 4